import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useRef,
  useCallback
} from "react";
import { io } from "socket.io-client";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
//import Peer from "peerjs";
import * as mediasoupClient from "mediasoup-client";
import { getProfile, getJwt } from "../../services/authservice";
import { getUser } from "../../services/users";
//import * as config from "../../utils/config";
import { updateMe, updateProducerId, updateMeetId } from "../videoMeetingSlice";
import {
  updateCurrentUser,
  updateContacts,
  updateConversations,
  updateMessages,
  updateActiveUser,
  updateEntireConversation,
  updateConversationsId,
  updateOnlineUsers,
  updateGroupMessages,
  updateContact
} from "../messengerSlice";
import { getConversation, getMessages, getGroupConversation, getGroupMessages } from "../../services/conversations";
import GroupCallModal from "../../pages/messenger/Chats/GroupCallModal";
//import { getConfig } from "../../utils/iceServer";
export const SocketContext = createContext();

export function useSocket() {
  return useContext(SocketContext);
}

const SocketProvider = (props) => {
  const videoMeeting = useSelector((state) => state.videoMeeting);
  const messenger = useSelector((state) => state.messenger);
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const [isGroupcallModal, setIsGroupCallModal] = useState(false);
  const [socket, setSocket] = useState();
  const [isMuted, setIsMuted] = useState(false);
  const [peers, setPeers] = useState({});
  const [streams, setStreams] = useState([]);
  const [localStream, setLocalStream] = useState({});
  const [isMeetingStart, setIsMeetingStart] = useState(false);
  const [isVideoTrack, setIsVideotrack] = useState(true);
  const [me, setMe] = useState({});
  const [group, setGroup] = useState(null);
  const [remoteUser, setRemoteUser] = useState(null);
  const [members, setMembers] = useState([]);
  const [isGroupCall, setGroupCall] = useState(false);
  const [isVideoCall, setIsVideoCall] = useState(false);
  const [isCaller, setIsCaller] = useState(false);


  let groupRef = useRef();
  let currentUserIdRef = useRef();
  //peerIdRef
  //let producerIdRef = useRef();
  //const userProducerMap = useRef(new Map()); // userId -> producerId[]
   let producersRef = useRef({ audio: null, video: null }); // Store both producers
  const userProducerMap = useRef(new Map()); // userId -> { audioProducerId, videoProducerId }

  let streamsRef = useRef();
  let myStream = useRef();
  let peersRef = useRef();
  let userStreamRef = useRef();
  let socketRef = useRef();
  const userConsumers = useRef(new Map());
  //let peerServerRef = useRef();
  streamsRef.current = streams;
  socketRef.current = socket;
  peersRef.current = peers;

  currentUserIdRef.current = videoMeeting.me._id;

  // Mediasoup refs
  const mediasoupDevice = useRef(null);
  const sendTransport = useRef(null);
  const recvTransport = useRef(null);
  const producer = useRef(null);
  const consumers = useRef(new Map());
  const callTimeoutRef = useRef(null);

  const recvTransports = useRef([]); // track all peer transports

  // Initialize Mediasoup device
  const initializeDevice = useCallback(async () => {
    try {
      const routerRtpCapabilities = await socketRef?.current.emitWithAck('getRouterRtpCapabilities');
      mediasoupDevice.current = new mediasoupClient.Device();
      await mediasoupDevice.current.load({ routerRtpCapabilities });
      console.log("initializeDevice");
    } catch (error) {
      toast.error('Failed to initialize media device');
      throw error;
    }
  }, [socketRef?.current]);

  // Transport creation
  const createTransport = useCallback(async (direction) => {
    try {
      const { transport: transportOptions } = await socketRef?.current.emitWithAck(
        direction === 'send' ? 'createProducerTransport' : 'createConsumerTransport',
        { direction, socketId: socketRef.current.id }
      );

      const transport = direction === 'send'
        ? mediasoupDevice.current.createSendTransport(transportOptions)
        : mediasoupDevice.current.createRecvTransport(transportOptions);

      // Add connection state handler


      transport.on('connectionstatechange', (state) => {
        console.log(`Transport state: ${state}`);
        console.log(`Transport ${transport.id} (${direction}) state:`, state);
        if (state === 'connected') {
          console.log('ICE connected, DTLS established');
        }
        if (state === 'failed') {
          transport.close();
        }
      });

      // Add transport creation log
      console.log('Transport created:', transport.id, direction);

      transport.on('connect', async ({ dtlsParameters }, callback, errback) => {
        try {
          await socketRef?.current.emitWithAck('connectTransport', {
            transportId: transport.id,
            dtlsParameters,
            direction: direction
          });
          callback();
        } catch (error) {
          errback(error);
        }
      });

      if (direction === 'send') {
        transport.on('produce', async (parameters, callback, errback) => {
          try {
            const { id } = await socketRef?.current.emitWithAck('transport-produce', {
              transportId: transport.id,
              kind: parameters.kind,
              rtpParameters: parameters.rtpParameters,
            });
            callback({ id });
          } catch (error) {
            errback(error);
          }
        });
      }
      return transport;
    } catch (error) {
      toast.error('Failed to create media transport');
      throw error;
    }
  }, [socketRef?.current]);


  // // Consumer Creation
  // const createConsumer = useCallback(async (producerId, userId, fromSocket) => {
  //   try {

  //     // Prevent self-consumption
  //     if (userId === currentUserIdRef.current) {
  //       console.log('Skipping self-consumption attempt');
  //       return;
  //     }
  //     const consumerData = await socketRef.current.emitWithAck('createConsumer', {
  //       producerId,
  //       rtpCapabilities: mediasoupDevice.current.rtpCapabilities,
  //       socketId: fromSocket
  //     });

  //     console.log("consumerData: ", consumerData);

  //     //const consumer = await recvTransport.current.consume(params);
  //     const consumer = await recvTransport.current.consume({
  //       id: consumerData.id,
  //       producerId: consumerData.producerId,
  //       kind: consumerData.kind,
  //       rtpParameters: consumerData.rtpParameters,
  //       paused: false
  //     });


  //     consumers.current.set(consumer.id, consumer);


  //     userProducerMap.current.set(userId, [
  //       ...(userProducerMap.current.get(userId) || []),
  //       producerId
  //     ]);

  //     // const stream = new MediaStream();
  //     // stream.addTrack(consumer.track);
  //     // Create stream reference
  //     const stream = new MediaStream([consumer.track]);
  //     const streamRef = { current: stream };

  //     addVideoStream({
  //       id: producerId,
  //       user: userId,
  //       //stream,
  //       stream: streamRef,
  //       //kind: params.kind
  //       kind: consumerData.kind
  //     });

  //     console.log("consumer data", {
  //       producerId: producerId,
  //       user: userId
  //     })
  //     //resume consumer
  //     await socketRef.current.emitWithAck('resume', {
  //       //consumerId: consumer.id
  //       producerId: producerId,
  //       socketId: fromSocket
  //     });
  //   } catch (error) {
  //     console.error('Consumer creation failed:', error);
  //     throw error;
  //   }
  // }, [createTransport]);


  // Consumer Creation for multiple producers
  const createConsumer1 = useCallback(async (producerId, userId, fromSocket, kind) => {
    try {
      if (userId === currentUserIdRef.current) {
        console.log('Skipping self-consumption attempt');
        return;
      }

      const consumerData = await socketRef.current.emitWithAck('createConsumer', {
        producerId,
        rtpCapabilities: mediasoupDevice.current.rtpCapabilities,
        socketId: fromSocket
      });

      console.log("consumerData: ", consumerData);

      const consumer = await recvTransport.current.consume({
        id: consumerData.id,
        producerId: consumerData.producerId,
        kind: consumerData.kind,
        rtpParameters: consumerData.rtpParameters,
        paused: false
      });
      // Store consumer in global map for later reference
      consumers.current.set(consumer.id, consumer);
      if (!userConsumers.current.has(userId)) {
        userConsumers.current.set(userId, new Set());
      }
      userConsumers.current.get(userId).add(consumer.id);
      // Update user producer map with kind information
      const userProducers = userProducerMap.current.get(userId) || {};
      if (kind === 'audio') {
        userProducers.audioProducerId = producerId;
      } else if (kind === 'video') {
        userProducers.videoProducerId = producerId;
      }
      userProducerMap.current.set(userId, userProducers);

      // Create or update stream for this user
      const stream = new MediaStream([consumer.track]);
      const streamRef = { current: stream };

      addVideoStream({
        id: `${userId}-${kind}`,
        user: userId,
        stream: stream,
        kind: kind
      });

  
      await socketRef.current.emitWithAck('resume', {
        producerId: producerId,
        socketId: fromSocket
      });
    } catch (error) {
      console.error('Consumer creation failed:', error);
      throw error;
    }
  }, []);


  const createConsumerOld = useCallback(async (producerId, userId, fromSocket, kind) => {
  try {
    if (userId === currentUserIdRef.current) {
      console.log('Skipping self-consumption attempt');
      return;
    }

    const consumerData = await socketRef.current.emitWithAck('createConsumer', {
      producerId,
      rtpCapabilities: mediasoupDevice.current.rtpCapabilities,
      socketId: fromSocket
    });

    console.log("consumerData: ", consumerData);

    const consumer = await recvTransport.current.consume({
      id: consumerData.id,
      producerId: consumerData.producerId,
      kind: consumerData.kind,
      rtpParameters: consumerData.rtpParameters,
      paused: false
    });

    consumers.current.set(consumer.id, consumer);

    // Update user producer map with kind information
    const userProducers = userProducerMap.current.get(userId) || {};
    if (kind === 'audio') {
      userProducers.audioProducerId = producerId;
    } else if (kind === 'video') {
      userProducers.videoProducerId = producerId;
    }
    userProducerMap.current.set(userId, userProducers);

    // Create MediaStream and ensure it's properly structured
    const stream = new MediaStream([consumer.track]);
    
    addVideoStream({
      id: `${userId}-${kind}`,
      user: userId,
      stream: stream, // Pass the actual MediaStream, not a ref
      kind: kind
    });

    await socketRef.current.emitWithAck('resume', {
      producerId: producerId,
      socketId: fromSocket
    });
  } catch (error) {
    console.error('Consumer creation failed:', error);
    throw error;
  }
}, []);

  const createConsumer = useCallback(async (producerId, userId, fromSocket, kind, transport) => {
  try {
    if (userId === currentUserIdRef.current) {
      console.log('Skipping self-consumption attempt');
      return;
    }

    const consumerData = await socketRef.current.emitWithAck('createConsumer', {
      producerId,
      rtpCapabilities: mediasoupDevice.current.rtpCapabilities,
      socketId: fromSocket
    });

    console.log("consumerData: ", consumerData);


    const consumer = await transport.consume({
      id: consumerData.id,
      producerId: consumerData.producerId,
      kind: consumerData.kind,
      rtpParameters: consumerData.rtpParameters,
      paused: false
    });

    consumers.current.set(consumer.id, consumer);

    // Update user producer map with kind information
    const userProducers = userProducerMap.current.get(userId) || {};
    if (kind === 'audio') {
      userProducers.audioProducerId = producerId;
    } else if (kind === 'video') {
      userProducers.videoProducerId = producerId;
    }
    userProducerMap.current.set(userId, userProducers);

    // Create MediaStream and ensure it's properly structured
    const stream = new MediaStream([consumer.track]);
    
    addVideoStream({
      id: `${userId}-${kind}`,
      user: userId,
      stream: stream, // Pass the actual MediaStream, not a ref
      kind: kind
    });

    await socketRef.current.emitWithAck('resume', {
      producerId: producerId,
      socketId: fromSocket
    });
  } catch (error) {
    console.error('Consumer creation failed:', error);
    throw error;
  }
}, []);
  // const addVideoStream = (streamObj) => {
  //     // Prevent adding own stream
  // if (streamObj.user === currentUserIdRef.current) {
  //   console.log('Blocking self stream addition');
  //   return;
  // }
  //   let isAlready = false;
  //   console.log("global state", streamsRef?.current);

  //   streamsRef?.current?.filter((obj) => {
  //     console.log("global state", obj);
  //     if (obj.id == streamObj.id) {
  //       isAlready = true;
  //     }
  //   });

  //   if (!isAlready) {
  //     let newStreams = [...streamsRef.current];
  //     newStreams.push(streamObj);
  //     setStreams([...newStreams]);
  //     toast.success(
  //       `${streamObj?.user?.contactName?.first +
  //       " " +
  //       streamObj?.user?.contactName?.last
  //       } Joined`,
  //       {
  //         position: "top-right",
  //         autoClose: 5000,
  //         hideProgressBar: false,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: true,
  //         progress: undefined,
  //         theme: "light",
  //       }
  //     );
  //   }
  // };

//  const addVideoStream = (streamObj) => {
//     if (streamObj.user === currentUserIdRef.current) {
//       console.log('Blocking self stream addition');
//       return;
//     }

//     let isAlready = false;
//     streamsRef?.current?.filter((obj) => {
//       if (obj.id === streamObj.id) {
//         isAlready = true;
//       }
//     });

//     if (!isAlready) {
//       let newStreams = [...streamsRef.current];
//       newStreams.push(streamObj);
//       setStreams([...newStreams]);
      
//       // Only show toast for video streams to avoid duplicate notifications
//       if (streamObj.kind === 'video') {
//         getUser(streamObj.user).then(userResponse => {
//           const user = userResponse.data;
//           toast.success(
//             `${user?.contactName?.first + " " + user?.contactName?.last} Joined`,
//             {
//               position: "top-right",
//               autoClose: 5000,
//               hideProgressBar: false,
//               closeOnClick: true,
//               pauseOnHover: true,
//               draggable: true,
//               progress: undefined,
//               theme: "light",
//             }
//           );
//         });
//       }
//     }
//   };

const addVideoStream = (streamObj) => {
  if (streamObj.user === currentUserIdRef.current) {
    console.log('Blocking self stream addition');
    return;
  }

  let isAlready = false;
  streamsRef?.current?.forEach((obj) => {
    if (obj.id === streamObj.id) {
      isAlready = true;
    }
  });

  if (!isAlready) {
    // Store the raw stream object 
    //setStreams(prev => [...prev, streamObj]);
    setStreams(prev => {
  if (prev.some(s => s.id === streamObj.id)) return prev; // already exists
  return [...prev, streamObj];
});

    // Only show toast for video streams
    if (streamObj.kind === 'video') {
      getUser(streamObj.user).then(userResponse => {
        const user = userResponse.data;
        toast.success(
          `${user?.contactName?.first} ${user?.contactName?.last} Joined`,
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          }
        );
      });
    }
  }
};

const addVideoStreamOld = (streamObj) => {
  if (streamObj.user === currentUserIdRef.current) {
    console.log('Blocking self stream addition');
    return;
  }

  let isAlready = false;
  streamsRef?.current?.filter((obj) => {
    if (obj.id === streamObj.id) {
      isAlready = true;
    }
  });

  if (!isAlready) {
    let newStreams = [...streamsRef.current];
    
    // Ensure the stream is properly set up
    const enhancedStreamObj = {
      ...streamObj,
      // Make sure stream is a MediaStream or ref with current
      stream: streamObj.stream?.current ? streamObj.stream : { current: streamObj.stream }
    };
    
    newStreams.push(enhancedStreamObj);
    setStreams([...newStreams]);
    
    // Only show toast for video streams to avoid duplicate notifications
    if (streamObj.kind === 'video') {
      getUser(streamObj.user).then(userResponse => {
        const user = userResponse.data;
        toast.success(
          `${user?.contactName?.first + " " + user?.contactName?.last} Joined`,
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          }
        );
      });
    }
  }
};




  // const removeVideoStream = (userId) => {
  //   if (userProducerMap.current.has(userId)) {
  //     const ids = userProducerMap.current.get(userId);
  //     setStreams(prev => prev.filter(stream => !ids.includes(stream.id)));
  //     userProducerMap.current.delete(userId);
  //   }
  // };

   const removeVideoStreamOld = (userId) => {
    if (userProducerMap.current.has(userId)) {
      // Remove both audio and video streams for this user
      setStreams(prev => prev.filter(stream => !stream.id.startsWith(`${userId}-`)));
      userProducerMap.current.delete(userId);
    }
  };
  const removeVideoStream = (userId) => {
  // Close all consumers for this user
  const consumerIds = userConsumers.current.get(userId);
  if (consumerIds) {
    consumerIds.forEach(id => {
      const consumer = consumers.current.get(id);
      if (consumer) {
        consumer.close();
        consumers.current.delete(id);
      }
    });
    userConsumers.current.delete(userId);
  }
  // Remove from streams state
  //setStreams(prev => prev.filter(stream => stream.id !== userId));
  setStreams(prev => prev.filter(stream => !stream.id.startsWith(`${userId}-`)));
  userProducerMap.current.delete(userId);
};


  const addNewPeer = (userId, call) => {
    setPeers({ ...peersRef.current, [userId]: call });
  };


  // const userJoined = useCallback(async ({ producerId, userId, peers }) => {
  //   const currentUserId = currentUserIdRef.current;
  //   if (!recvTransport.current) {
  //     try {
  //       recvTransport.current = await createTransport('recv');
  //     } catch (error) {

  //       console.error('Failed to create receive transport:', error);
  //       return;
  //     }
  //   }
  //   // Filter out existing producers using userProducerMap
  //   const newPeers = peers.filter(peer => {
  //     const existingProducers = userProducerMap.current.get(peer.userId) || [];
  //     return (
  //       peer.userId !== currentUserId &&
  //       !existingProducers.includes(peer.producerId)
  //     );
  //   });
  
  //   await Promise.all(newPeers.map(async (peer) => {
  //     if (!userProducerMap.current.has(peer.userId)) {
  //       await createConsumer(peer.producerId, peer.userId, peer.socketId);
  //     }
  //   }));
  // }, [createConsumer]);

   const userJoined1 = useCallback(async ({ producers, userId }) => {
    const currentUserId = currentUserIdRef.current;
    
    if (!recvTransport.current) {
      try {
        recvTransport.current = await createTransport('recv');
      } catch (error) {
        console.error('Failed to create receive transport:', error);
        return;
      }
    }

    // Handle multiple producers (audio and video)
    if (producers && producers.audioProducerId) {
      await createConsumer(producers.audioProducerId, userId, producers.socketId, 'audio');
    }
    
    if (producers && producers.videoProducerId) {
      await createConsumer(producers.videoProducerId, userId, producers.socketId, 'video');
    }
  }, [createConsumer, createTransport]);


  const userJoined = useCallback(async ({ producers, userId }) => {
  const currentUserId = currentUserIdRef.current;
  // Create a separate receive transport for each new peer to avoid conflicts
  let recvTransport;
  try {
    recvTransport = await createTransport('recv');
    recvTransports.current.push(recvTransport); // Keep track of all receive transports
  } catch (error) {
    console.error('Failed to create receive transport for user', userId, error);
    return;
  }
  // Consume audio if present
  if (producers && producers.audioProducerId) {
    await createConsumer(producers.audioProducerId, userId, producers.socketId, 'audio', recvTransport);
  }
  // Consume video if present
  if (producers && producers.videoProducerId) {
    await createConsumer(producers.videoProducerId, userId, producers.socketId, 'video', recvTransport);
  }
}, [createConsumer, createTransport]);

  // const startServices = async () => {
  //   const id = getProfile()._id;
  //   const res = await getUser(id);
  //   setMe(res.data);
  //   dispatch(updateMe(res.data));

  //   const userLeft = async ({ userId }) => {
  //     console.log("user left with", userId, streamsRef?.current);
  //     removeVideoStream(userId);
  //     const u = await getUser(userId);
  //     toast.warning(
  //       `${u.data.contactName.first + " " + u.data.contactName.last} Left`,
  //       {
  //         position: "top-right",
  //         autoClose: 5000,
  //         hideProgressBar: false,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: true,
  //         progress: undefined,
  //         theme: "light",
  //       }
  //     );
  //     console.log("user left", userId, streamsRef?.current, streamsRef?.current.length, isGroupCall);

  //     setGroupCall((state) => {
  //       if (state && streamsRef?.current?.length == 0) {
  //         endMeeting('')
  //       }

  //     })

  //   }

    


  //   //userJoinedMeeting
  //   socketRef?.current?.on("userJoinedMeeting", userJoined);

  //   //userJoinedGroupConversation
  //   socketRef?.current?.on("userJoinedGroupConversation", async (data) => {
  //     console.log("userJoinedGroupConversation event received:", data);
  //     ////////// this part need review
  //     setGroupCall(true);
  //     setIsGroupCallModal(false);
  //     //////////
  //     await userJoined(data);
  //     navigate("/messenger/videomeeting-session");
  //     console.log("Navigation complete");
  //   });

  //   socketRef?.current?.on("userLeft", userLeft);


  //   //incomingGroupCall
  //   socketRef?.current?.on("incomingGroupCall", async (data) => {
  //     console.log("incomming group call", data);
  //     // Validate group object structure
  //     if (!data.groupId?._id || !data.groupId?.name) {
  //       toast.error("Invalid group data received");
  //       return;
  //     }
  //     groupRef.current = data.groupId;
  //     setGroup(data.groupId);
  //     // Ignore if it's our own call
  //     //if (data.user === videoMeeting.me._id) return;
  //     if (data.user === currentUserIdRef.current) return;
  //     data.callType == "video" ? setIsVideoCall(true) : setIsVideoCall(false);
  //     const res = await getUser(data.user);
  //     setRemoteUser(res.data);

  //     setIsGroupCallModal(true);
  //     //await startMeeting(data.groupId.name, true, (data.callType == 'video' ? true : false));
  //   })
  // };

  const startServices = async () => {
    const id = getProfile()._id;
    const res = await getUser(id);
    setMe(res.data);
    dispatch(updateMe(res.data));

    const userLeft = async ({ userId }) => {
      console.log("user left with", userId);
      removeVideoStream(userId);
      const u = await getUser(userId);
      toast.warning(
        `${u.data.contactName.first + " " + u.data.contactName.last} Left`,
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        }
      );

      if (isGroupCall && streamsRef?.current?.length === 0) {
        endMeeting('')
      }
    };

    socketRef?.current?.on("userJoinedMeeting", userJoined);
    socketRef?.current?.on("userJoinedGroupConversation", async (data) => {
      console.log("userJoinedGroupConversation event received:", data);
      setGroupCall(true);
      setIsGroupCallModal(false);
      await userJoined(data);
      navigate("/messenger/videomeeting-session");
    });

    socketRef?.current?.on("userLeft", userLeft);

    socketRef?.current?.on("incomingGroupCall", async (data) => {
      console.log("incoming group call", data);
      if (!data.groupId?._id || !data.groupId?.name) {
        toast.error("Invalid group data received");
        return;
      }
      
      groupRef.current = data.groupId;
      setGroup(data.groupId);
      
      if (data.user === currentUserIdRef.current) return;
      
      data.callType === "video" ? setIsVideoCall(true) : setIsVideoCall(false);
      const res = await getUser(data.user);
      setRemoteUser(res.data);
      setIsGroupCallModal(true);
    });
  };

  // const startGroupCall = async (members, group, callVideoType) => {
  //   let newMembers = [];
  //   for (const m of members) {
  //     // if (m._id !== videoMeeting.me._id) {
  //     //   newMembers.push(m._id);
  //     // }
  //     if (m._id !== currentUserIdRef.current) {
  //       newMembers.push(m._id);
  //     }
  //   }
  //   groupRef.current = group;
  //   setGroup(group);

  //   setMembers(members);
  //   setGroupCall(true);
  //   callVideoType == "video" ? setIsVideoCall(true) : setIsVideoCall(false);
  //   console.log("group call group", group);
  //   console.log("group call initiated", videoMeeting.me._id, newMembers);
  //   socketRef?.current.emit("initiateGroupCall", {
  //     user: videoMeeting.me._id,
  //     members: newMembers,
  //     groupId: group,
  //     conversationId: group._id,
  //     callType: callVideoType
  //   });

  //   await startMeeting(group.name, true, (callVideoType == "video" ? true : false));
  //   setIsCaller(true);
  // }

  const startGroupCall = async (members, group, callVideoType) => {
    let newMembers = [];
    for (const m of members) {
      if (m._id !== currentUserIdRef.current) {
        newMembers.push(m._id);
      }
    }
    
    groupRef.current = group;
    setGroup(group);
    setMembers(members);
    setGroupCall(true);
    callVideoType === "video" ? setIsVideoCall(true) : setIsVideoCall(false);
    
    console.log("group call initiated", currentUserIdRef.current, newMembers);
    
    // Start meeting first to get producer IDs
    await startMeeting(group.name, true, (callVideoType === "video"));
    
    // Then initiate call with both producer IDs
    socketRef?.current.emit("initiateGroupCall", {
      user: currentUserIdRef.current,
      members: newMembers,
      groupId: group,
      conversationId: group._id,
      callType: callVideoType,
      audioProducerId: producersRef.current.audio?.id,
      videoProducerId: producersRef.current.video?.id
    });

    setIsCaller(true);
  };

  // const answerGroupCall = async () => {
  //   console.log("answerCall", videoMeeting.me._id);
  //   console.log("answerCall currentUserIdRef.current", currentUserIdRef.current);
  //   setGroupCall(true);
  //   setIsGroupCallModal(false);
  //   // Ensure meeting is fully initialized first
  //   await startMeeting(groupRef.current.name, true, isVideoCall);
  //   console.log("answer", group, producerIdRef?.current);
  // }


  const answerGroupCall = async () => {
    console.log("answerGroupCall", currentUserIdRef.current);
    setGroupCall(true);
    setIsGroupCallModal(false);
    await startMeeting(groupRef.current.name, true, isVideoCall);
  };

  // //meeting+group call
  // const startMeeting = async (name, isGroupCall = false, callVideoType = true) => {
  //   dispatch(updateMeetId(name));

  //   if (!mediasoupDevice.current?.loaded) await initializeDevice();
  //   sendTransport.current = await createTransport('send');
  //   recvTransport.current = await createTransport('recv');
  //   const newStream = await navigator.mediaDevices.getUserMedia({
  //     video: callVideoType,
  //     audio: true,
  //   });

  //   setLocalStream(newStream);
  //   myStream.current = newStream;

  //   const track = callVideoType
  //     ? newStream.getVideoTracks()[0]
  //     : newStream.getAudioTracks()[0];


  //   producer.current = await sendTransport.current.produce({
  //     track,
  //     //encodings: callVideoType ? [{ scalabilityMode: 'S3T3' }] : undefined,
  //      encodings: callVideoType ? [
  //         { scalabilityMode: 'L3T3', dtx: true },
  //         { scalabilityMode: 'L2T3', dtx: true, scaleResolutionDownBy: 2 },
  //         { scalabilityMode: 'L1T3', dtx: true, scaleResolutionDownBy: 4 }
  //       ] : undefined,
  //     codecOptions: callVideoType ? {
  //       videoGoogleStartBitrate: 1000
  //     } : {
  //       opusStereo: true,
  //       opusDtx: true
  //     }
  //   });


  //   dispatch(updateProducerId(producer.current.id));
  //   producerIdRef.current = producer.current.id;
  //   userProducerMap.current.set(currentUserIdRef.current, [producerIdRef.current]);

  //   // Join room
  //   const joinResponse = await socketRef.current.emitWithAck('joinGroup', {
  //     //userId: videoMeeting.me._id,
  //     userId: currentUserIdRef.current,
  //     isGroupCall,
  //     //conversationId: group?._id,
  //     conversationId: groupRef.current._id,
  //     //rtpCapabilities: mediasoupDevice.current.rtpCapabilities,
  //     producerId: producerIdRef?.current
  //   });


  //   if (!isGroupCall) {
  //     console.log("beofre emit", name, producerIdRef.current, videoMeeting.me._id);
  //     socketRef?.current?.emit("joinMeeting", {
  //       meetingID: name,
  //       producerId: producerIdRef.current,
  //       userId: videoMeeting.me._id,
  //     });
  //   }


  //   setIsMeetingStart(true);
  //   //still need to be reviewed
  //   const currentUserId = getProfile()._id;
  //   if (joinResponse.peers) {
  //     const currentUserId = getProfile()._id;
  //     const existingProducerIds = streamsRef.current.map(s => s.id);

  //     const filteredPeers = joinResponse.peers.filter(peer =>
  //       peer.userId !== currentUserId &&
  //       peer.producerId !== producerIdRef.current &&
  //       !existingProducerIds.includes(peer.producerId)
  //     );

  //     await Promise.all(filteredPeers.map(async (peer) => {
  //       try {
  //         console.log("Creating consumer for initial peer:", peer);
  //         await createConsumer(peer.producerId, peer.userId, peer.socketId);
  //       } catch (error) {
  //         console.error('Failed to create initial consumer:', error);
  //       }
  //     }));
  //   }

  //   setIsMeetingStart(true);


  // };

   // Updated startMeeting with multiple producers
  const startMeeting = async (name, isGroupCall = false, callVideoType = true) => {
    dispatch(updateMeetId(name));

    if (!mediasoupDevice.current?.loaded) await initializeDevice();
    sendTransport.current = await createTransport('send');
    //recvTransport.current = await createTransport('recv');
    
    const newStream = await navigator.mediaDevices.getUserMedia({
      video: callVideoType,
      audio: true,
    });

    setLocalStream(newStream);
    myStream.current = newStream;

    // Produce AUDIO track (always)
    const audioTrack = newStream.getAudioTracks()[0];
    producersRef.current.audio = await sendTransport.current.produce({
      track: audioTrack,
      codecOptions: {
        opusStereo: true,
        opusDtx: true
      }
    });

    // Produce VIDEO track only for video calls
    let videoProducer = null;
    if (callVideoType) {
      const videoTrack = newStream.getVideoTracks()[0];
      producersRef.current.video = await sendTransport.current.produce({
        track: videoTrack,
        encodings: [
          { scalabilityMode: 'L3T3', dtx: true },
          { scalabilityMode: 'L2T3', dtx: true, scaleResolutionDownBy: 2 },
          { scalabilityMode: 'L1T3', dtx: true, scaleResolutionDownBy: 4 }
        ],
        codecOptions: {
          videoGoogleStartBitrate: 1000
        }
      });
      videoProducer = producersRef.current.video;
    }

    // Store both producer IDs
    userProducerMap.current.set(currentUserIdRef.current, {
      audioProducerId: producersRef.current.audio.id,
      videoProducerId: producersRef.current.video?.id
    });

    // Join room with both producer IDs
    const joinResponse = await socketRef.current.emitWithAck('joinGroup', {
      userId: currentUserIdRef.current,
      isGroupCall,
      conversationId: groupRef.current._id,
      audioProducerId: producersRef.current.audio.id,
      videoProducerId: producersRef.current.video?.id
    });

    if (!isGroupCall) {
      socketRef?.current?.emit("joinMeeting", {
        meetingID: name,
        audioProducerId: producersRef.current.audio.id,
        videoProducerId: producersRef.current.video?.id,
        userId: currentUserIdRef.current,
      });
    }

    setIsMeetingStart(true);

    // Handle existing peers
    // if (joinResponse.peers) {
    //   const existingProducerIds = streamsRef.current.map(s => s.id);
      
    //   const filteredPeers = joinResponse.peers.filter(peer =>
    //     peer.userId !== currentUserIdRef.current &&
    //     !existingProducerIds.includes(`${peer.userId}-audio`) &&
    //     !existingProducerIds.includes(`${peer.userId}-video`)
    //   );

    //   await Promise.all(filteredPeers.map(async (peer) => {
    //     try {
    //       console.log("Creating consumer for initial peer:", peer);
    //       if (peer.audioProducerId) {
    //         await createConsumer(peer.audioProducerId, peer.userId, peer.socketId, 'audio');
    //       }
    //       if (peer.videoProducerId) {
    //         await createConsumer(peer.videoProducerId, peer.userId, peer.socketId, 'video');
    //       }
    //     } catch (error) {
    //       console.error('Failed to create initial consumer:', error);
    //     }
    //   }));
    // }

    if (joinResponse.peers) {
  const existingProducerIds = streamsRef.current.map(s => s.id);
  
  const filteredPeers = joinResponse.peers.filter(peer =>
    peer.userId !== currentUserIdRef.current &&
    !existingProducerIds.includes(`${peer.userId}-audio`) &&
    !existingProducerIds.includes(`${peer.userId}-video`)
  );

  await Promise.all(filteredPeers.map(async (peer) => {
    try {
      console.log("Creating consumer for initial peer:", peer);
      
      // Create a fresh receive transport for this peer
      const peerRecvTransport = await createTransport('recv');

      //Consume audio and video using that transport
      if (peer.audioProducerId) {
        await createConsumer(peer.audioProducerId, peer.userId, peer.socketId, 'audio', peerRecvTransport);
      }
      if (peer.videoProducerId) {
        await createConsumer(peer.videoProducerId, peer.userId, peer.socketId, 'video', peerRecvTransport);
      }
    } catch (error) {
      console.error('Failed to create initial consumer:', error);
    }
  }));
}

    setIsMeetingStart(true);
  };

  // //end meeting
  // const endMeeting = (meetingID) => {

  //   console.log("end", peersRef.current);
  //   if (isMeetingStart) {
  //     //this code is related to peerjs
  //     // for (const key in peersRef.current) {
  //     //   peersRef.current[key].close(key);
  //     // }
  //     setIsMeetingStart(false);
  //     setPeers({});
  //     setStreams([]);
  //   }
  //   console.log("isGroupCall", isGroupCall)
  //   if (isGroupCall) {

  //     console.log("end group call", group?._id, videoMeeting.me._id)

  //     socketRef?.current?.emit("leaveGroupConversation", {
  //       conversationId: group?._id,
  //       userId: videoMeeting.me._id,
  //       producerId: producerIdRef.current,
  //     });

  //     if (isCaller) {
  //       const messageObj = {
  //         sender: videoMeeting.me._id,
  //         receiver: members,
  //         message: "",
  //         media: [],
  //         conversationId: group?._id,
  //         updatedAt: new Date().toLocaleString(),
  //         createdAt: new Date().toLocaleString(),
  //         callInfo: {
  //           isCall: true,
  //           callType: isVideoCall.current ? "Video" : "Audio",
  //           duration: "00" + ":" + "00",
  //           time: new Date().toLocaleString(),
  //         },
  //       };

  //       console.log("end with", messageObj);
  //       // updateMessages(messageObj);
  //       dispatch(
  //         updateMessages({
  //           key: messenger.activeUser,
  //           message: messageObj,
  //         })
  //       );
  //       socket?.emit("sendMessage", messageObj);
  //     }


  //   } else {
  //     socketRef?.current?.emit("leaveMeeting", {
  //       meetingID: meetingID,
  //       userId: videoMeeting.me._id,
  //     });
  //   }

  //   setIsMuted(false);
  //   setIsVideotrack(true);
  //   setGroup(null);
  //   //peerServerRef?.current?.destroy();

  //   // setLocalStream((state) => {
  //   //   if (state) {
  //   //     state?.getTracks()?.forEach((track) => {
  //   //       track.stop()
  //   //       track.release && track.release();
  //   //     });
  //   //   }
  //   // })
  //   // Close transports
  //   sendTransport.current?.close();
  //   recvTransport.current?.close();

  //   // Close producer
  //   if (producer.current) producer.current.close();

  //   // Close consumers
  //   consumers.current.forEach(consumer => consumer.close());
  //   consumers.current.clear();

  //   // Stop local streams
  //   if (myStream.current) {
  //     myStream.current.getTracks().forEach(track => track.stop());
  //     setLocalStream(null);
  //   }

  //   //setLocalStream(null);
  //   setGroupCall(false);
  //   navigate(-1);
  // };

    // Updated endMeeting
  const endMeeting = (meetingID) => {
    console.log("end meeting", peersRef.current);
    

    // Stop local streams first to release camera/mic
    if (myStream.current) {
      myStream.current.getTracks().forEach(track => track.stop());
      setLocalStream(null);
    }
  
    if (isGroupCall) {
      console.log("end group call", group?._id, currentUserIdRef.current);

      socketRef?.current?.emit("leaveGroupConversation", {
        conversationId: group?._id,
        userId: currentUserIdRef.current,
        audioProducerId: producersRef.current.audio?.id,
        videoProducerId: producersRef.current.video?.id,
      });

      if (isCaller) {
        const messageObj = {
          sender: currentUserIdRef.current,
          receiver: members,
          message: "",
          media: [],
          conversationId: group?._id,
          updatedAt: new Date().toLocaleString(),
          createdAt: new Date().toLocaleString(),
          callInfo: {
            isCall: true,
            callType: isVideoCall ? "Video" : "Audio",
            duration: "00" + ":" + "00",
            time: new Date().toLocaleString(),
          },
        };

        dispatch(
          updateMessages({
            key: messenger.activeUser,
            message: messageObj,
          })
        );
        socketRef?.current.emit("sendMessage", messageObj);
      }
    } else {
      socketRef?.current?.emit("leaveMeeting", {
        meetingID: meetingID,
        userId: currentUserIdRef.current,
      });
    }


    // Close producers
    if (producersRef.current.audio) producersRef.current.audio.close();
    if (producersRef.current.video) producersRef.current.video.close();
    producersRef.current = { audio: null, video: null };

    // Close consumers
    consumers.current.forEach(consumer => consumer.close());
    consumers.current.clear();
    userConsumers.current.clear();

    // Close transports
    recvTransports.current.forEach(t => t.close());
    sendTransport.current?.close();
    recvTransport.current?.close();

    // Reset state
    setIsMuted(false);
    setIsVideotrack(true);
    setGroup(null);
    setIsMeetingStart(false);
    setPeers({});
    setStreams([]);
    setGroupCall(false);
    navigate(-1);
  };
// Media control functions unchanged
  const muteStream = () => {
    if (localStream) {
      const audioTracks = localStream.getAudioTracks();
      audioTracks.forEach((track) => {
        track.enabled = false;
        setIsMuted(true);
      });
    }
  };

  // Function to unmute the local stream
  const unmuteStream = () => {
    if (localStream) {
      const audioTracks = localStream.getAudioTracks();
      audioTracks.forEach((track) => {
        track.enabled = true;
        setIsMuted(false);
      });
    }
  };

  const turnOffVideo = () => {
    if (localStream) {
      const videoTracks = localStream.getVideoTracks();
      videoTracks.forEach((track) => {
        track.enabled = false;
        setIsVideotrack(false);
      });
    }
  };

  // Function to turn on the video track
  const turnOnVideo = () => {
    if (localStream) {
      const videoTracks = localStream.getVideoTracks();
      videoTracks.forEach((track) => {
        track.enabled = true;
        setIsVideotrack(true);
      });
    }
  };


  const fetchUpdatedMessages = async () => {
    const token = await getProfile();
    const res = await getUser(token._id);
    const contacts = res.data.contacts;
    const currentUser = res.data;

    dispatch(updateCurrentUser({ ...currentUser, contacts: [] }));
    dispatch(updateContacts(contacts));
    dispatch(updateEntireConversation([]));
    if (currentUser?._id) {
      for (let contact of contacts) {
        const conversation = await getConversation(
          currentUser?._id,
          contact?.user?._id
        );
        console.log("conv is", conversation.data);
        const messages = await getMessages(conversation?.data?._id);
        console.log("messages", messages?.data);
        dispatch(updateConversations([messages?.data]));
      }
    }
  }

  const getMessengerData = async () => {
    const token = await getProfile();
    const res = await getUser(token._id);
    const contacts = res.data.contacts;
    const currentUser = res.data;

    dispatch(updateCurrentUser({ ...currentUser, contacts: [] }));
    // dispatch(updateContacts(contacts));
    console.log("contacts", contacts)
    const unsorted = [];

    if (currentUser?._id) {
      for (let contact of contacts) {
        if (contact?.user) {
          const conversation = await getConversation(
            currentUser?._id,
            contact?.user?._id
          );
          console.log("conv is", conversation.data);
          // dispatch(updateConversationsId(conversation?.data?._id));
          const messages = await getMessages(conversation?.data?._id);
          console.log("messages", messages?.data);
          // dispatch(updateConversations([messages?.data]));
          unsorted.push({
            contact: contact,
            conversationId: conversation?.data?._id,
            messages: messages?.data.reverse()
          })
        }
      }
    }

    console.log("groups before")
    const resp = await getGroupConversation();
    console.log("group api res", resp)
    // let groups = [];

    if (resp.status === 200) {
      console.log("groups", resp);
      for (let group of resp.data) {
        const groupContact = { ...group, isGroupChat: true };
        // groups.push(groupContact);
        // dispatch(updateConversationsId(group?._id));
        const groupMesseges = await getGroupMessages(group._id);
        console.log("groupmessages", groupMesseges)
        // dispatch(updateConversations([groupMesseges.data]))
        unsorted.push({
          contact: groupContact,
          conversationId: group?._id,
          messages: groupMesseges.data.reverse()
        })
      }
    }

    const data = await Promise.all(unsorted.sort((a, b) => {
      console.log("in promise", a.messages)
      if (a.messages.length > 0 && b.messages.length > 0) {
        const first = new Date(a.messages[a.messages.length - 1].createdAt)
        const second = new Date(b.messages[b.messages.length - 1].createdAt)
        return second - first
      }
      else {
        return false;
      }
    }))
    // dispatch(updateContacts(contacts.concat(groups)));

    console.log("data is", data);

    for (const item of data) {
      dispatch(updateContact(item.contact));
      dispatch(updateConversationsId(item.conversationId));
      dispatch(updateConversations([item.messages]))
    }

    socketRef?.current?.emit("getUsers");

    socketRef?.current?.on("getGroupMessage", (data) => {
      console.log("get message", data)


      dispatch(updateGroupMessages(data));
      toast.info(
        `${data.message}`,
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        }
      );

    });



    socketRef?.current?.on("getMessage", (d) => {
      console.log("message received", d);
      let sender;
      data.find((item, key) => {
        const contact = item.contact;
        if (!contact.isGroupChat && contact?.user?._id === d.sender) {
          console.log(contact.user._id, d.sender)
          sender = contact.user;
          dispatch(
            updateMessages({
              message: d
            })
          );

          if (!d?.callInfo?.isCall) {
            toast.info(
              `${sender.name}: ${d.message}`,
              {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              }
            );
          }

        }
      });


    });

  };





  useEffect(() => {
    //let isMounted = true;
    const getToken = async () => {
      const res = await getProfile();
      return res;
    }
    getToken().then((token) => {
      //if (!isMounted) return;
      console.log("token is", token)
      if (token) {
        //const newSocket = io("wss://messengerbackend.aivoluon.com", {
        const newSocket = io(process.env.REACT_APP_SOCKET_URL, {
          auth: { token: getJwt() },
          transports: ["websocket", "polling"],
          reconnection: true,
          reconnectionDelay: 1000,
          //reconnectionDelayMax: 1500,
          reconnectionDelayMax: 5000,
          //reconnectionAttempts: Infinity,
          reconnectionAttempts: 10,
          autoConnect: true,
          secure: true
        });
        // newSocket.connect();
        newSocket.on("connect", async () => {
          newSocket.emit("addUser", {
            userId: token?._id,
          });

          // const disconnectHandler = () => {
          //   console.log("Socket disconnected");
          //   if (isMounted) newSocket.connect();
          // };

          //newSocket.on("disconnect", disconnectHandler);

          newSocket.on("getUsers", async (data) => {
            console.log("get users data", data);
            let onlinnContacts = [];
            const token = await getProfile();
            const res = await getUser(token._id);
            const contacts = res.data.contacts;
            for (const key in contacts) {
              for (const index in data) {
                if (data[index]?.userId == contacts[key]?.user?._id) {
                  console.log("matched", contacts[index])
                  onlinnContacts.push(contacts[key]);
                }
              }
            }
            console.log("online users", onlinnContacts)
            dispatch(updateOnlineUsers(onlinnContacts));
          });

          console.log("Socket connected ", newSocket.connected, newSocket.id, "user id", token._id);
        });

        newSocket.on("disconnect", (e) => {
          console.log("Socket disconnected ", newSocket.connected, e);
          newSocket.connect();
        });


        setSocket(newSocket);
        startServices();
        console.log(newSocket);
        getMessengerData();
      }

    });

  }, []);

  return (
    <SocketContext.Provider
      value={{
        socket,
        startMeeting,
        me,
        localStream: myStream,
        myStream: localStream,
        endMeeting,
        streams,
        muteStream,
        unmuteStream,
        turnOffVideo,
        turnOnVideo,
        isMuted,
        isVideoTrack,
        userStreamRef,
        fetchUpdatedMessages,
        startGroupCall,
        answerGroupCall,
        isGroupCall,
        isVideoCall
      }}
    >
      {
        isGroupcallModal &&
        <GroupCallModal
          isOpen={isGroupcallModal}
          toggleCallModal={() => setIsGroupCallModal(!isGroupcallModal)}
          isVideo={isVideoCall}
          caller={remoteUser}
          user={group}
          inComming={true}
          declineCall={() => { }}
          answerCall={() => { }}
        />
      }
      {props.children}
    </SocketContext.Provider>
  );
};

export default SocketProvider;
